<template>
  <nav class="gnb">
    <ul class="nav-tabs">
      <li :class="classnameSemester">
        <a @click="onClick(0)" aria-controls="home" role="tab" data-toggle="tab">
          {{ $i18n.translate('학기별현황') }}
        </a>
      </li>
      <li :class="classnamePeriod">
        <a @click="onClick(1)" aria-controls="profile" role="tab" data-toggle="tab">
          {{ $i18n.translate('기간별현황') }}
        </a>
      </li>
      <li :class="classnameSubject">
        <a @click="onClick(2)" aria-controls="messages" role="tab" data-toggle="tab">
          {{ $i18n.translate('과목별현황') }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "customTab",
  props: {
    active: Number,
  },
  data: () => ({
    activeIndex: -1,
    routers: {
      student: [
        { name: '/student/status-semester' },
        { name: '/student/status-period' },
        { name: '/student/status-subject' },
      ],
      professor: [
        { name: '/professor/status-semester' },
        { name: '/professor/status-period' },
        { name: '/professor/status-subject' },
      ]
    },
  }),
  computed: {
    classnameSemester() {
      return this.activeIndex === 0 ? 'nav-tabs-item active' : 'nav-tabs-item';
    },
    classnamePeriod() {
      return this.activeIndex === 1 ? 'nav-tabs-item active' : 'nav-tabs-item';
    },
    classnameSubject() {
      return this.activeIndex === 2 ? 'nav-tabs-item active' : 'nav-tabs-item';
    },
  },
  methods: {
    onClick(index) {
      this.activeIndex = index;
    },
    goto(index) {
      let role = this.$session.get("role");
      let routers = this.routers[role];
      if (this.$route.name !== routers[index].name) {
        this.$router.push(routers[index]);
      }
    }
  },
  mounted() {
    this.activeIndex = typeof this.active === "number" ? this.active : 0;
  },
  watch: {
    activeIndex(index) {
      if (index >= 0) {
        this.goto(index)
      }
    }
  }
}
</script>
